function PrivacyPolicy() {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 20px', color: '#e4e4e7', fontFamily: 'system-ui, sans-serif', lineHeight: 1.7 }}>
      <h1 style={{ fontSize: 28, marginBottom: 4 }}>Privacy Policy</h1>
      <p style={{ color: '#71717a', fontSize: 13, marginBottom: 24 }}>Last updated: April 4, 2026</p>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>1. Introduction</h2>
        <p>MeWare ("we", "our", "us") is a personal finance management application. This Privacy Policy explains how we collect, use, and protect your information when you use our application.</p>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>2. Information We Collect</h2>
        <p>We collect the following types of information:</p>
        <ul style={{ paddingLeft: 24 }}>
          <li><strong>Account credentials</strong> - Login information to access the application.</li>
          <li><strong>Financial data</strong> - Transaction data synced from your linked financial accounts through SimpleFIN, or imported via CSV. This includes transaction dates, amounts, descriptions, account names, and categories.</li>
          <li><strong>User-entered data</strong> - Categories, tags, memos, rules, and other data you create within the application.</li>
        </ul>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>3. How We Use Your Information</h2>
        <p>Your information is used solely to:</p>
        <ul style={{ paddingLeft: 24 }}>
          <li>Display and manage your financial transactions</li>
          <li>Categorize and report on your spending</li>
          <li>Provide personalized financial insights and reports</li>
          <li>Sync data with connected financial institutions</li>
        </ul>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>4. Data Storage and Security</h2>
        <p>Your data is stored securely in Microsoft Azure cloud services. We use industry-standard encryption and authentication mechanisms to protect your information. Access to the application is protected by authentication tokens.</p>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>5. Third-Party Services</h2>
        <p>We integrate with the following third-party services:</p>
        <ul style={{ paddingLeft: 24 }}>
          <li><strong>SimpleFIN</strong> - For syncing financial account data. SimpleFIN has its own privacy policy governing how they handle your data.</li>
          <li><strong>Microsoft Azure</strong> - For data storage and hosting.</li>
        </ul>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>6. Data Sharing</h2>
        <p>We do not sell, trade, or otherwise transfer your personal or financial information to outside parties. Your data is only accessible to you through your authenticated account.</p>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>7. Data Retention</h2>
        <p>Your data is retained for as long as your account is active. You may request deletion of your data at any time by contacting us.</p>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>8. Your Rights</h2>
        <p>You have the right to:</p>
        <ul style={{ paddingLeft: 24 }}>
          <li>Access your personal data</li>
          <li>Request correction of inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Export your data</li>
        </ul>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>9. Changes to This Policy</h2>
        <p>We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated revision date.</p>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>10. Contact</h2>
        <p>If you have any questions about this Privacy Policy, please contact us through the application.</p>
      </section>

      <div style={{ borderTop: '1px solid #2a2b35', paddingTop: 16, marginTop: 32, textAlign: 'center' }}>
        <a href="/" style={{ color: '#8b5cf6', textDecoration: 'none' }}>Back to MeWare</a>
        {' | '}
        <a href="/terms" style={{ color: '#8b5cf6', textDecoration: 'none' }}>Terms and Conditions</a>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
